<ng-container
  *ngTemplateOutlet="
    listTemplate;
    context: {
      items: value,
      show: show
    }
  "
></ng-container>

<ng-template #listTemplate let-show="show" let-items="items">
  @if (items.length > show) {
  <atx-accordion>
    <atx-accordion-panel #panel [content]="accordionContentRef">
      <atx-accordion-header>
        @for (value of items | slice: 0:show; track value) {
        <div [innerHTML]="value"></div>
        } @if (!panel.open) {
        <a
          role="button"
          class="font-weight-bold"
          i18n="
            basketManager|Truncate long list show
            more@@basketManagerTruncateMessageShowMore"
          >+{{ items.length - show }} More</a
        >
        }
      </atx-accordion-header>
    </atx-accordion-panel>
    <ng-template #accordionContentRef>
      @for (value of items | slice: show; track value) {
      <div [innerHTML]="value"></div>
      }
      <a
        class="font-weight-bold"
        role="button"
        (click)="panel.toggleMenu()"
        i18n="
          basketManager|Truncate long list show
          less@@basketManagerTruncateMessageShowLess"
        >Show Less</a
      ></ng-template
    >
  </atx-accordion>
  } @else { @for (value of value; track value) {
  <div [attr.data-e2e]="'item-' + value" [innerHTML]="value"></div>
  } }
</ng-template>
